import React from 'react';
import { JOB_LOG_SOURCE, LogLevel, LogLine } from '../../services/JobMonitorService';
import styles from '../JobsPage.module.css';

interface LogLineListProps {
  lines: LogLine[];
  showSource: boolean;
}

const LEVEL_STYLE: Record<LogLevel, string> = {
  trace: styles.logTrace,
  debug: styles.logDebug,
  info: styles.logInfo,
  warning: styles.logWarning,
  error: styles.logError,
  critical: styles.logCritical,
};

const formatTime = (timestamp: string | null): string => {
  if (!timestamp) {
    return '--:--:--.---';
  }
  const at = new Date(timestamp);
  const pad = (value: number, width = 2) => String(value).padStart(width, '0');
  return `${pad(at.getHours())}:${pad(at.getMinutes())}:${pad(at.getSeconds())}.${pad(at.getMilliseconds(), 3)}`;
};

// "job" is the job's own container; anything else is a service it drives, whose
// container name is long and repetitive on every line.
export const sourceLabel = (source: string): string =>
  source === JOB_LOG_SOURCE ? 'job' : source.replace(/^quant-ai-/, '');

/** One line per row, the same way wherever log output is shown. */
export const LogLineList: React.FC<LogLineListProps> = ({ lines, showSource }) => (
  <>
    {lines.map((line, index) => (
      <div key={`${line.timestamp ?? index}-${index}`} className={`${styles.logLine} ${LEVEL_STYLE[line.level]}`}>
        <span className={styles.logTime}>{formatTime(line.timestamp)}</span>
        {showSource && <span className={styles.logSource}>{sourceLabel(line.source)}</span>}
        <span className={styles.logLevel}>{line.level.toUpperCase()}</span>
        <span className={styles.logMessage}>{line.message}</span>
      </div>
    ))}
  </>
);
